import React from 'react';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-card">
          <video
            className="hero-media"
            autoPlay
            muted
            loop
            playsInline
            preload="auto"
            poster="https://images.unsplash.com/photo-1586521995568-39c0602dfb75?q=80&w=1920&auto=format&fit=crop"
            aria-hidden="true"
          >
            <source src="/banner.mp4" type="video/mp4" />
          </video>
          <div className="hero-overlay" />
          <div className="hero-content">
            <h1>Transform idle inventory into working capital</h1>
            <p>We help retailers, brands, and enterprises turn returns, excess, and retired IT assets into recovered value — with secure data destruction, compliant processing, and fast routing to the highest-value channels.</p>
            <div className="stats">
              <div className="stat">
                <span className="stat-number">30+</span>
                <span className="stat-label">Years Experience</span>
              </div>
              <div className="stat">
                <span className="stat-number">352</span>
                <span className="stat-label">Clients Served</span>
              </div>
              <div className="stat">
                <span className="stat-number">50%+</span>
                <span className="stat-label">E-Waste Reduction</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
